import { createSlice } from '@reduxjs/toolkit';

type VirtualNumberLoadingState = {
  isLoading: boolean;
};

const initialState: VirtualNumberLoadingState = {
  isLoading: false,
};

export const virtualNumberLoadingSlice = createSlice({
  name: 'virtualNumberLoading',
  initialState,
  reducers: {
    setVirtualNumberLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});
